import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import FieldHeader from './FieldHeader';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import { isEmpty, isAllWhiteSpace } from '../../utils/obj-utils';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

class FormLookupField extends Component {
    constructor(props) {
        super(props);
        const { validState, defaultValue } = props;

        this.initialState = {
            isFilled: !isEmpty(defaultValue),
            lookupValue: isEmpty(defaultValue) ? '' : defaultValue,
            areSuggestionsVisible: false,
            isValid: true,
            errorMessage: ''
        };

        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }
        this.state = this.initialState;

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.displaySuggestedPlayers = this.displaySuggestedPlayers.bind(this);
        this.displayHeader = this.displayHeader.bind(this);
        this.handleCloseSuggestions = this.handleCloseSuggestions.bind(this);
        this.handleFieldIsFilled = this.handleFieldIsFilled.bind(this);
    }

    handleChange(event, newLookupValue) {
        const { name, onChange } = this.props;
        const { value } = event.target;
        let updatedLookUpValue = newLookupValue !== undefined ? newLookupValue : value;

        if ((typeof updatedLookUpValue) !== 'string') {
            updatedLookUpValue = '';
        }

        this.handleFieldIsFilled(updatedLookUpValue);
        this.setState((state) => ({
            ...state,
            lookupValue: updatedLookUpValue,
            areSuggestionsVisible: true
        }));
        onChange({ target: { name, value: updatedLookUpValue, type: 'text' } });
    }

    handleBlur() {
        this.handleCloseSuggestions();
    }

    handleFieldIsFilled(value) {
        const isFilled = value !== '';
        this.setState((state) => ({ ...state, isFilled }));
    }

    displaySuggestedPlayers() {
        const { suggestions } = this.props;
        const { lookupValue } = this.state;

        if (isEmpty(suggestions)) {
            return (<div>No results found!</div>);
        }

        const filteredSuggestions = suggestions.filter((suggestion) => {
            if (isEmpty(lookupValue) || isAllWhiteSpace(lookupValue)) {
                return true;
            }

            return suggestion.firstName.toLowerCase().includes(lookupValue.toLowerCase()) ||
                suggestion.lastName.toLowerCase().includes(lookupValue.toLowerCase());
        });

        if (isEmpty(filteredSuggestions)) {
            return <div>No results found!</div>;
        }

        const suggestionsUi = filteredSuggestions.map((filteredSuggestion) => {
            return (
                <li key={uniqueId()}
                    className='form-lookup-suggestion-item search-autocomplete__suggestions-item'
                    onClick={(event) => {
                        this.handleChange(event, filteredSuggestion.label);
                        this.handleCloseSuggestions();
                    }}>
                    <div className='search-autocomplete__suggestions-link'>
                        <div className='form-lookup-suggestion-field player-suggestion'>
                            <div className='player-suggestion__firstname'>{filteredSuggestion.firstName}</div>
                            <div className='player-suggestion__lastname'>{filteredSuggestion.lastName}</div>
                        </div>
                    </div>
                </li>);
        });

        return suggestionsUi;
    }

    displayHeader() {
        const { name,
            headerTitle,
            headerText,
            isHidden } = this.props;

        if (isHidden)
            return;

        return <FieldHeader style={{ display: isHidden ? 'none' : 'block' }}
            fieldName={name}
            headerTitle={headerTitle}
            headerText={headerText}
            textClassName={'text-info'}>
        </FieldHeader>;
    }

    handleCloseSuggestions() {
        this.setState({ areSuggestionsVisible: false });
    }

    render() {
        const { lookupValue, areSuggestionsVisible } = this.state;
        const {
            name,
            autocompleteValue,
            label,
            isHidden,
            size,
            validState,
            formRef
        } = this.props;
        const { isValid, errorMessage } = validState || this.state;
        const { isFilled } = this.state;

        return (
            <Fragment>
                {this.displayHeader()}
                <div className={`leaderboard__search-autocomplete  ${size || formMessageConstants.emptyString} ${isFilled ? formStyleConstants.isFilled : ''} ${!isValid ? formStyleConstants.isInvalid : ''}`}
                    ref={formRef}
                    data-dc-component='form-field'
                    data-form-control
                    style={{ display: isHidden ? 'none' : 'block' }}>
                    <div className='search-autocomplete is-active'>
                        <div className='form-lookup-container search-autocomplete__container'>
                            <input
                                className='form-lookup-input search-autocomplete__input'
                                type='text'
                                autoComplete={autocompleteValue}
                                id={name}
                                name={name}
                                placeholder={label}
                                value={lookupValue}
                                onClick={this.handleChange}
                                onChange={this.handleChange} />
                            <button
                                onClick={this.handleCloseSuggestions}
                                className='form-lookup-button search-autocomplete__button'
                                type='button'>
                                <svg className='search-autocomplete__icon icon'
                                    focusable='false'
                                    width='15'
                                    height='15'>
                                    {!areSuggestionsVisible ? <use xlinkHref="#icon-search"></use> : null}
                                    {areSuggestionsVisible ? <use xlinkHref="#icon-cross"></use> : null}
                                </svg>
                            </button>
                        </div>
                        <div className={`form-lookup-input-scrollbar search-autocomplete__suggestions  ${areSuggestionsVisible ? 'is-visible' : ''} scrollbar`}>
                            <ul className='search-autocomplete__suggestions-list'>
                                {this.displaySuggestedPlayers()}
                            </ul>
                        </div>
                    </div>
                    {!isValid ? <ul className="form-field__error-list filled">
                        <li className="form-field__error-item">{errorMessage}</li>
                    </ul> : null}
                </div >
            </Fragment>
        );
    }
}

FormLookupField.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    suggestions: PropTypes.array.isRequired,
    autocompleteValue: PropTypes.string,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    size: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    validState: PropTypes.object
};

export default FormLookupField;
